export default __webpack_public_path__ + "static/media/search.4e4fd5f2.svg";